<script>
    import question_data_raw from "./questions/v3.1.0.json";
    import questionset_usertags from "./questions/questionset_usertags.json";
    import QuestionSet from "./QuestionSet.svelte";
    import { responses } from "./stores.js";
    let show_responses = false; // for debugging: show all responses
    export let enable_debug; // enable debugging tools

    export let user_language;

    // track whether the form is currently submitting
    let submitting = false;


    const submitEndpoint = "/submit/";

    // reformat question data as a list of objects
    let question_sets = Object.entries(question_data_raw).map((x) => {
        return { ...x[1], questionset_id: x[0] };
    });

    // by default, shuffle the question order (don't shuffle in dev because that makes testing harder)
    if (!enable_debug) {
        question_sets.sort((a, b) => 0.5 - Math.random());
    }
    question_sets.unshift(questionset_usertags); // add the usertags questions at the beginning of the survey

    // fill up the "responses" object with nulls
    $responses = {};
    question_sets.forEach((question_set) => {
        $responses[question_set["questionset_id"]] = {};
        question_set["questions"].forEach((question) => {
            $responses[question_set["questionset_id"]][
                question["question_id"]
            ] = "";
        });
    });

    // check for usertags passed through URL
    let params = new URLSearchParams(window.location.search);
    if (params.get("tag")) {
        let usertags = params.get("tag").split(":");
        $responses["usertags"]["usertags_organization"] = usertags[0];
        // if organization is provided in URL, prevent editing
        if($responses["usertags"]["usertags_organization"]) {
            question_sets[0]["questions"].find(item => item.question_id === "usertags_organization")["protected"] = true;
        }
        if (usertags[1]) {
            $responses["usertags"]["usertags_division"] = usertags[1];
            // if division is provided in URL, prevent editing 
            if($responses["usertags"]["usertags_division"]) {
                question_sets[0]["questions"].find(item => item.question_id === "usertags_division")["protected"] = true;
            }
        }
        if (usertags[2]) {
            // [team is always user-editable]
            $responses["usertags"]["usertags_team"] = usertags[2];
        }
    }

    // in prod, if no organization has been provided, redirect to main page (we don't want untagged entries)
    if (!$responses["usertags"]["usertags_organization"] && !enable_debug) {
        window.location.replace("/");
    }

    let current_question_set_idx = 0;
</script>

<div class="survey">
    <form
        action={submitEndpoint}
        method="post"
        id="reflectionForm"
        on:submit={() => {
            submitting = true;
        }}
    >
        {#each Object.entries(question_sets) as [idx, question_set]}
            <QuestionSet
                {question_set}
                {user_language}
                bind:responses={$responses}
                bind:show_responses
                {enable_debug}
                is_active={current_question_set_idx == parseInt(idx)}
                bind:current_question_set_idx
                is_last_question_set={current_question_set_idx ==
                    question_sets.length - 1}
                is_first_question_set={current_question_set_idx == 0}
                {submitting}
            />
        {/each}
        <!-- user responses are tracked as a JSON object to be submitted as a single field -->
        <input
            type="hidden"
            name="user_responses"
            value={JSON.stringify($responses)}
        />
    </form>
</div>

<style>
    .survey {
        margin: 2em auto;
    }
</style>
